import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import { UseMutationOptions } from '@tanstack/react-query';

type ProcessMessageFlowResponse =
  | { status: 'success' }
  | { status: 'error'; message: string };

type ProcessMessageFlowArgs = {
  [key: string]: any;
  bcc: boolean;
  case: string;
  content: string;
  subject: string;
  to: string;
};

const processMessageFlow = async (formData: ProcessMessageFlowArgs) => {
  const response = await API.post<ProcessMessageFlowResponse>(
    '/process_message_flow.jsp',
    formData,
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    },
  );

  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    ProcessMessageFlowResponse,
    unknown,
    ProcessMessageFlowArgs
  >,
  'mutationFn'
>;

const useProcessMessageFlowMutation = (options?: ReactQueryMutationOptions) => {
  return useAppMutation({
    mutationFn: processMessageFlow,
    ...options,
  });
};

export default useProcessMessageFlowMutation;
